import { getUserRoles, isSessionValid } from "../../components/Utils";
import { PWA_ACCESS, PWA_ENTRY } from "../layouts/pwaConfig";

export const languagePickerPath = () => `${window.contextPath}/${PWA_ENTRY.languagePath}`;

export const readPwaSession = () => {
  const valid = isSessionValid();
  let denied = false;
  try {
    denied = (getUserRoles() || []).some((role) => PWA_ACCESS.deniedRoles.includes(role));
  } catch {
    return { valid: false, denied: false };
  }
  return { valid, denied };
};

export const isPwaSignedIn = () => {
  const { valid, denied } = readPwaSession();
  return valid && !denied && localStorage.getItem("DfsWeb.onboardingPending") !== "true";
};
